export const en = {
    users: {
        one: '{count} user',
        some: '{count} users',
        many: '{count} users',
        none: '{count} users',
    },
};
